import React from 'react';
import { Spinner } from 'react-bootstrap';

/**
 * Standardized loading spinner component.
 * @param {string} message - Loading message (default: 'Loading...')
 * @param {boolean} inline - If true, renders a small inline spinner for buttons (default: false)
 */
const LoadingSpinner = ({ message = 'Loading...', inline = false }) => {
  if (inline) {
    return (
      <>
        <Spinner animation="border" size="sm" className="me-2" />
        {message}
      </>
    );
  }

  return (
    <div className="d-flex flex-column align-items-center justify-content-center p-5">
      <Spinner animation="border" variant="primary" className="mb-3" role="status">
        <span className="visually-hidden">{message}</span>
      </Spinner>
      <p className="text-muted">{message}</p>
    </div>
  );
};

export default LoadingSpinner;